         
import { MDBBtn, MDBCard, MDBCardBody, MDBCardHeader, MDBCol, MDBRow, MDBTabs, MDBTabsItem, MDBTabsLink } from 'mdb-react-ui-kit';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { DomainContext } from "../../context/DomainProvider";
import { deleteUser } from "../../utils/Common";
import User from './User';
import UserCreateModal from "./UserCreateModal";
function UsersView() {
    const { domainId } = useParams();
    const [isUserCreateModalOpen, setIsUserCreateModalOpen] = useState(false);
    const handleIsUserCreateModalOpenToggle = () => setIsUserCreateModalOpen(!isUserCreateModalOpen);
  
    
    const inventoryUrl = process.env.REACT_APP_INVENTORY_URL;
    const { selectDomains, domainData, setDomainData } = useContext(DomainContext);

    const users = domainData?.users ;
    const [activeTab, setActiveTab] = useState(users && users[0] && users[0].uid);
    
    useEffect(() => {
      if (users?.length > 0) {
          setActiveTab(users[0].uid);
      }
  }, [users, setActiveTab]);
  
    
    const handleTabChange = (uid) => {
        setActiveTab(uid);
    }

    
    // const handleUpdateUserProfile = async (updatedUser) => {
    //     // Update locally
    //     const updatedUsers = users.map(user => {
    //       if (user.uid === updatedUser.uid) {
    //         return updatedUser;
    //       }
    //       return user;
    //     });
        
    //     // Update in the backend
    //     try {
    //       const response = await axios.put(`${inventoryUrl}/userprofiles/${updatedUser.uid}`, updatedUser);
    //       if (response.status === 200) {
    //         // If successful, update the state
    //         setDomainData(prevState => {
    //             const updatedUsers = prevState.users.map(user => {
    //               if (user.uid === updatedUser.uid) {
    //                 return response.data;
    //               }
    //               return user;
    //             });
                
    //             return {
    //               ...prevState,
    //               users: updatedUsers,
    //             };
    //           });
              
    //       } else {
    //         console.error("Couldn't update the user in the backend");
    //       }
    //     } catch (error) {
    //       console.error('Error updating user:', error);
    //     }
    //   };
      
    
    // const handleDelete = async () => {
    //     // Assuming activeTab is the uId
    //     const uId = activeTab;
    //     // Get the domainId from the selected user
    //     const userToDelete = users.find(user => user.uid === uId);
    //     if (!userToDelete) {
    //         console.error('No user selected for deletion');
    //         return;
    //     }
    //     const domainId = userToDelete.ou;
        
    //     try {
    //         const response = await axios({
    //             method: 'DELETE',
    //             url: `${inventoryUrl}/userprofiles/domain/${domainId}/user/${uId}`,               
    //             withCredentials: true,
    //         });
    
    //         if (response.status === 200) {
    //             const remainingUsers = users.filter(user => user.uid !== uId);
              
                
    //             setDomainData({
    //                 users:remainingUsers
                   
    //             });
    //         }
    //     } catch (error) {
    //         console.error('Error:', error);
    //     }
    // };
  

    return (
        
        <MDBRow className='text-center rounded mt-3 gy-2 gx-3 align-items-center'>
  <MDBCol style={{ maxWidth: "400rem" ,borderRadius: "12px"}}>
            <MDBCard className='text-center rounded mt-3 gy-2 gx-3 align-items-center'>
            {/* <MDBCardImage cascade style={{ height: '20rem' , borderRadius: "12px"}}   src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20%281%29.jpg" />
            <MDBCardOverlay   className="text-center rounded" style={{ marginTop: "80px"}}>
        */}
                <MDBCardBody>
                {users?.length>0 &&  <MDBCardHeader background="light"  className="text-center rounded">
                    <MDBTabs className='card-header-tabs'>
                        {users && users.map((user, index) => (
                          //  !user.loggedIn &&
                            <MDBTabsItem key={index}>
                                <MDBTabsLink active={activeTab === user.uid} onClick={() => handleTabChange(user.uid)}>
                                {user.picture && !user.picture.includes('test') ? (
  <img
    className="rounded shadow-1 mb-3"
    src={user.picture}
    alt=""
    style={{ width: '25px', height: '35px' }}
  />
) : (
  user.uid
)}

                                </MDBTabsLink>
                            </MDBTabsItem>
                        )
                        )}
                    </MDBTabs>
                </MDBCardHeader>}
                    <MDBRow className='text-center rounded mt-3 gy-2 gx-3 align-items-center  justify-content-center'>
                        {users?.map((user, index) => (
                            activeTab === user.uid && (
                                <MDBCol className='mb-4' key={index} md='3'>
                                    <User employee={user}    />
                                </MDBCol>
                            )
                        ))}
                    </MDBRow>
                    <div className={users?.length>0 ?"d-grid gap-2 d-md-block ": "d-grid gap-2"} style={{ marginBottom: '20px' }} >
 
            <MDBBtn type="button" className="btn-lg py-3 px-5 mb-2 mb-md-4 me-md-2"  onClick={handleIsUserCreateModalOpenToggle}>  ADD
                                    </MDBBtn>
          {users?.length>0  && <MDBBtn color='success' className="btn-lg py-3 px-5 mb-2 mb-md-4 me-md-2"  onClick={() => deleteUser(domainId,activeTab, setDomainData)}>Delete</MDBBtn>}
            </div>
                </MDBCardBody>
                {/* </MDBCardOverlay> */}
            </MDBCard>

            {isUserCreateModalOpen &&
                <UserCreateModal
                    isUserCreateModalOpen={isUserCreateModalOpen}
                    handleIsUserCreateModalOpenToggle={handleIsUserCreateModalOpenToggle}
                    baseUrl={inventoryUrl}
                   domainName={selectDomains.find(domain => domain.value === domainId)?.text}                
                    domainId={domainId}
                />}
         
         </MDBCol>
               </MDBRow>
                  
    );
}


export default UsersView;
